import type { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';
import { Button } from '@gik/ui/Button';
import { Wishlist } from '@gik/ui/SvgIcon/GikIcons/Wishlist';
import { SvgIcon } from '@gik/ui/SvgIcon/SvgIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

interface ISeeFullWishlistButtonProps {
  inkindPage: InkindPageAPIModel;
}

export default function SeeFullWishlistButton({ inkindPage }: ISeeFullWishlistButtonProps) {
  const { t } = useTranslation();

  return (
    <Button type={'a'} href={`/inkinds/${inkindPage.routeId}/wishlist`} block prepend={<SvgIcon Icon={Wishlist} />}>
      {t(translationKeys.seeFull).toString()}
    </Button>
  );
}
